/*
 * @Author: liushengjiang 1947448287@qq.com
 * @Date: 2021-12-28 15:26:11
 * @LastEditors: liushengjiang 1947448287@qq.com
 * @LastEditTime: 2023-12-13 09:30:10
 * @FilePath: \petro-web-chemicals-sellerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "assets/styles/reset.css";
import "assets/styles/border.css"; //用于解决多倍屏下的1px边框问题
import "assets/styles/main.css";
import 'common/js/directive';
import fastClick from "fastclick";
import { fetch } from "@/request/http.js";
import vueCookies from "vue-cookies";
import "amfe-flexible";
import vant from "vant";
import "vant/lib/index.css";
// 修改一些全局的组件默认样式
import "assets/styles/my-vant.styl";
import { Lazyload } from 'vant';


import util from "common/js/util";
import calculator from "common/js/calculator";
import common from "@/request/constants";
//1.在main.js中引入过滤器
import filter from "common/js/filter";
// 引入console
//import 'assets/vconsole';
import 'hooper/dist/hooper.css';

Vue.use(vant);
Vue.use(Lazyload);
//Vant 修改为自动按需引入的方式，
// import { Swipe, SwipeItem, Icon, Form } from "vant";
// Vue.use(Swipe);
// Vue.use(SwipeItem);
// Vue.use(Icon);
// Vue.use(Form);

Vue.use(vueCookies);

Vue.config.productionTip = false;
fastClick.prototype.focus = function (targetElement) { // 解决浏览器不聚焦的问题
  let length
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length
    targetElement.focus()
    targetElement.setSelectionRange(length, length)
  } else {
    targetElement.focus()
  }
}
fastClick.attach(document.body);

Vue.prototype.$fetch = fetch;
Vue.prototype.$utils = util;
Vue.prototype.$common = common;
Vue.prototype.$calculator = calculator;


//2.在main.js中注册全局过滤器
Object.keys(filter).forEach((key) => {
  Vue.filter(key, filter[key]);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
